module.exports = __webpack_public_path__ + "src/projects/eBook/assets/pdf/book2/pdf-1.pdf";